import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@environments/environment';
import {Contrat} from '@domain/contrat/contrat';
import {Result} from '@domain/common/http/result';
import {first} from "rxjs/operators";
import {Compte} from '@domain/contrat/compte';
import {Injectable} from "@angular/core";

/**
 * Service de gestion des contrats
 *
 * @author Yannick Gauthier
 * @date 18/08/2025
 */
@Injectable({
    providedIn: 'root'
})
export class ContratService {
    /**
     * Constructeur
     *
     * @param http Client HTTP
     */
    constructor(private http: HttpClient) {}

    /**
     * Récupère un contrat par son ID
     *
     * @param idContrat ID du contrat
     * @returns Observable du contrat
     */
    getContrat(idContrat: number): Observable<Result> {
        let params = new HttpParams().set('idContrat', idContrat.toString());
        return this.http.post<Result>(`${environment.baseUrl}/controller/Contrat/loadContrat`, null, {params: params}).pipe(first());
    }

    /**
     * Sauvegarde un contrat
     *
     * @param contrat Contrat à sauvegarder
     * @returns Observable du résultat
     */
    saveContrat(contrat: Contrat): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/Contrat/saveContrat`, contrat);
    }
    
    /**
     * Supprime un contrat
     *
     * @param contrat Contrat à supprimer
     * @returns Observable du résultat
     */
    deleteContrat(contrat: Contrat): Observable<Result<boolean>> {
        return this.http.post<Result<boolean>>(`${environment.baseUrl}/controller/Contrat/deleteContrat`, contrat);
    }

    /**
     * Récupère une carte par son ID
     *
     * @param idContrat ID du contrat
     * @param idCarte ID de la carte
     * @returns Observable du résultat contenant la carte
     */
    getCarte(idContrat: number, idCarte: string): Observable<Result<any>> {
        let params = new HttpParams()
            .set('idContrat', idContrat.toString())
            .set('idCarte', idCarte ? idCarte.toString() : '0');
        return this.http.post<Result<any>>(`${environment.baseUrl}/controller/Contrat/loadCarte`, null, {params: params});
    }

    /**
     * Sauvegarde une carte
     * 
     * @param carte Carte à sauvegarder
     * @param isCreation Indique si c'est une création
     * @returns Observable contenant le résultat de la sauvegarde
     */
    saveCarte(carte: Compte, isCreation: boolean): Observable<Result> {
        return this.http.post<Result<Compte>>(`${environment.baseUrl}/controller/Contrat/saveCarte/${isCreation}`, carte);
    }

    /**
     * Supprime une carte
     *
     * @param carte Carte à supprimer
     * @returns Observable du résultat
     */
    deleteCarte(carte: Compte): Observable<Result<boolean>> {
        return this.http.post<Result<boolean>>(`${environment.baseUrl}/controller/Contrat/deleteCarte`, carte);
    }
}
